"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassengerListOptions = void 0;
const react_1 = __importDefault(require("react"));
const Item_1 = require("./Item");
require("./index.scss");
const className = 'reservation-passengers-options-block';
const PassengerListOptions = (props) => {
    const { onChange, options, passengerIdx, disabled, } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__list` }, options.map((passengerOption, idx) => (react_1.default.createElement("div", { key: `rplo:${passengerIdx}:${idx}`, className: `${className}__item` },
            react_1.default.createElement(Item_1.PassengerListOptionsItem, { isChecked: passengerOption.isChecked, onChange: (data) => {
                    onChange({
                        id: passengerOption.id,
                        isChecked: data === null || data === void 0 ? void 0 : data.isChecked,
                    });
                }, title: passengerOption.title, tooltip: passengerOption.tooltip, disabled: disabled, warning: passengerOption.warning })))))));
};
exports.PassengerListOptions = PassengerListOptions;
//# sourceMappingURL=index.js.map